import { SettingsPayload, SettingsState, UserOption } from "./settings.types";

export const toOptions = (arr: any[]): UserOption[] =>
    Array.isArray(arr)
        ? (arr.map(i => {
            if (i?.value !== undefined && typeof i?.text === "string")
                return { value: String(i.value), text: i.text };
            if (i?.user && i.user.id)
                return { value: String(i.user.id), text: `${i.user.first_name} ${i.user.last_name}` };
            return null;
        }).filter(Boolean) as UserOption[])
        : [];

export const buildPayload = (form: HTMLFormElement, s: SettingsState): SettingsPayload => ({
    users: {
        "personal-admin": toOptions(s?.users?.["personal-admin"] ?? s?.personalAdmins ?? []),
        "personal-delegate": toOptions(s?.users?.["personal-delegate"] ?? s?.personalDelegates ?? []),
    },
    working_days: s.workingDays,
    worktime: (form as any).worktime.value,
    breaktime: (form as any).breaktime.value,
    allowWorkTimeInterruption: s.allowWorkTimeInterruption ? 1 : 0,
    vacation: (form as any).vacation.value,
    maxWorkTime: (form as any).maxWorkTime.value,
    flexitime: {
        allowFlexitime: (form as any)["allowFlexitime"].checked,
        flexitimeStart: (form as any)["flexitime-start"]?.value,
        flexitimeEnd: (form as any)["flexitime-end"]?.value,
    },
    forceBreak: {
        forceBreakActive: (form as any)["forceBreakActive"].checked,
        forceBreakAfter: (form as any)["breaktime-mandatory"]?.value,
        forceBreakTime: (form as any)["breaktime-min"]?.value,
    },
});
